module.exports = __webpack_public_path__ + "static/media/16.2547cc1b.jpg";